export default "/assets/site/images/cluster-red.svg?ccedc27f6ca8a093ce9c13a001788ee4";